import React from 'react';
import styled from 'App/styled';
import PhoneIcon from 'components/Icons/Phone';
import { useSelector } from 'react-redux';
import { State } from 'store/types';
import { platformNames } from 'shared/constants';
import {
  CUSTOMER_CARE_NUMBER,
  CUSTOMER_CARE_NUMBER_MAN,
  CALL_US,
  TIMING,
} from 'constants/footer';

const Wrap = styled.div`
  color: #ffffff;
  display: flex;
  margin-left: 55px;
`;

const Icon = styled.div`
  padding-right: 10px;
`;

const Paragraph = styled.p`
  text-transform: uppercase;
`;

const Timing = styled.div`
  margin-top: ${({ theme }) => theme.spacing.spacing50};
`;

const Component = () => {
  const customerCareNumber = useSelector(
    ({ remoteConfig }): State => remoteConfig?.configs?.customerCareNum
  );
  // const customerCareEmail = useSelector(
  //   ({ remoteConfig }): State => remoteConfig?.configs?.customerCareEmail
  // );
  const isMen = __PLATFORM__ === platformNames.MEN;
  const contactNum = isMen ? CUSTOMER_CARE_NUMBER_MAN : CUSTOMER_CARE_NUMBER;
  return (
    <Wrap>
      <Icon>
        <PhoneIcon />
      </Icon>
      <div>
        <Paragraph>
          {`${CALL_US} `}
          {!isMen && <br />}
          {customerCareNumber || contactNum}
        </Paragraph>
        {/* {isMen && (
          <Paragraph>
            {`${WRITE_TO_US} `}
            <Email href={`mailto:${CUSTOMER_CARE_EMAIL_MAN}`}>
              {customerCareEmail || CUSTOMER_CARE_EMAIL_MAN}
            </Email>
          </Paragraph>
        )} */}
        <Timing>{TIMING}</Timing>
      </div>
    </Wrap>
  );
};

export default Component;
